<template>
  <div class="outwork-diff">
    <div class="title">
      <span class="title__h3">{{
        $lange == "en"
          ? "Working hours by project"
          : "各项目的工程师出差时长对比"
      }}</span>
      <span class="title__tip">
        ({{ $lange == "en" ? "Real-time" : "实时查询" }})
      </span>
    </div>
    <div class="content">
      <div class="search">
        <RemoteSelect
          v-model="jobIds"
          size="mini"
          style="width: 270px"
          mapId="jobId"
          class="spacing"
          multiple
          collapse-tags
        />
        <el-button class="spacing" @click="doSearch" size="mini">
          {{ this.$lange == "en" ? "view" : "查看" }}
        </el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" max-height="450" size="mini" border>
          <el-table-column prop="jobId" label="Job ID"></el-table-column>
          <el-table-column
            prop="customerName"
            :label="$lange == 'en' ? 'customer' : '客户名称'"
          ></el-table-column>
          <el-table-column
            v-for="code in codes"
            :prop="code.code"
            :label="saveName(code)"
            :key="code.id"
          ></el-table-column>
        </el-table>
      </div>
      <div class="chart">
        <p class="no_data" v-if="tableData.length == 0">
          {{ $lange == "en" ? "No Data" : "暂无数据" }}
        </p>
        <e-charts
          v-else
          style="width: 100%"
          :options="options"
          auto-resize
        ></e-charts>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import RemoteSelect from "../components/RemoteSelect.vue";

import ECharts from "../components/Charts.vue";
import "echarts/lib/chart/pie";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/grid";
import "echarts/lib/component/dataZoom";
import theme from "../graph/theme";

function formatterNoZero(params) {
  try {
    const value = Number(params.value);
    if (value !== 0) return value;
    else return "";
  } catch (e) {
    return "";
  }
}

export default {
  name: "OutworkDiff",
  components: { RemoteSelect, ECharts },
  props: {
    codes: Array,
  },
  data() {
    return {
      jobIds: "",
      tableData: [],
      updateTime: "",
    };
  },
  computed: {
    options() {
      const xAxisData = this.tableData.map(
        (item) => `Job:${item.jobId}\n\n${item.customerName}`
      );
      console.log(xAxisData);
      const series = this.codes.map((item) => {
        const seriesData = this.tableData.map((data) => ({
          name: data.customerName,
          value: Number(data[item.code]),
        }));
        return {
          name: item.title,
          type: "bar",
          data: seriesData,
          label: {
            show: true,
            position: "top",
            formatter: formatterNoZero,
          },
        };
      });

      return {
        ...theme,
        legend: {
          top: 16,
          left: 32,
        },
        grid: {
          left: 16,
          containLabel: true,
          show: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: xAxisData,
        },
        yAxis: {
          type: "value",
        },
        dataZoom: [
          {
            show: true,
            // yAxisIndex: [0],
            start: 0,
            end: 100,
          },
          {
            type: "inside",
            start: 0,
            end: 100,
          },
        ],
        series,
      };
    },
  },
  methods: {
    saveName(data) {
      if (this.$lange == "en") {
        if (data.extraData && data.extraData.en) {
          return data.extraData.en;
        }
        return data.title;
      } else {
        return data.title;
      }
    },
    doSearch() {
      this.fetchOutworkData(this.jobIds);
    },
    filterTableData(raw) {
      if (!raw) return [];
      return raw.map((item) => {
        const { workHoursCountList, ...other } = item;
        return workHoursCountList.reduce(
          (pre, cur) => {
            pre[cur.code] = cur.travelWorkHour;
            return pre;
          },
          { ...other }
        );
      });
    },
    async fetchOutworkData(jobIds) {
      //   const res = await this.ccRequest.do(
      //     "admin/fsb/employee/report/countProductWorkHour",
      //     { jobIds },
      //     "POSTJSON"
      //   );

      const res = await axios.post(
        "/admin/fsb/employee/report/countProductWorkHour",
        jobIds
      );
      this.tableData = Object.freeze(this.filterTableData(res.data));
      console.log(this.tableData);
    },
  },
};
</script>

<style lang="scss" scoped>
.outwork-diff {
  .table {
    max-width: 800px;
    margin: 16px 0;
  }

  .title {
    border-bottom: 1px solid #e4e4e4;
    padding: 10px 20px;
  }

  .title__h3 {
    font-size: 18px;
    font-weight: bold;
    display: inline-block;
    margin-right: 8px;
  }
  .title__tip {
    color: #ccc;
  }

  .content {
    padding: 8px;
  }

  .spacing {
    &:not(:first-child) {
      margin-left: 8px;
    }
  }

  .chart {
    min-width: 600px;
    min-height: 200px;
    margin: 16px 0;
    border: 1px solid #aaa7a788;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .no_data {
    color: #aaa7a7;
  }
}
.el-table {
  border: 1px solid #aaa7a788;
  font-size: 14px;
}
.el-table ::v-deep th.el-table__cell.is-leaf,
.el-table ::v-deep td.el-table__cell {
  border-bottom: 1px solid #aaa7a788;
  border-right: 1px solid #aaa7a788;
}
</style>
